import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Carousel, Col, Container, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft, faAngleRight, faExclamation, faSearch, faSpinner} from '@fortawesome/free-solid-svg-icons';
import Api from '../../../services/Api';
import {Button, Empty, Form, Input, notification, Spin, Table, Modal, message } from 'antd';
import Countdown, {zeroPad} from 'react-countdown';
import _ from 'lodash';
import moment from 'moment';
import HelperGeneral from '../../../helpers/HelperGeneral';
import UserInfo from '../../auth/UserInfo';
import {reduxStore} from '../../../services/redux/ReduxIndex';
import animation from '../../../assets/coupon_animation.json';
import Lottie from 'react-lottie';
import {QrcodeOutlined, CameraOutlined} from '@ant-design/icons';
import { Html5Qrcode } from 'html5-qrcode';
import ReactHtmlParser from "react-html-parser";
import Slider from "react-slick";
import helperGeneral from "../../../helpers/HelperGeneral";

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            width: window.innerWidth,
            product_data: [],
            transactions: [],
            pagination: {
                current: 1,
                pageSize: 15,
            },
            loading: true,
            productInputLoading: false,
            sliders: [],
            sliderLoading: true,
            brands: [],
            top5Loading: true,
            getTop5Products: false,
            getTop5SellerProducts: false,
            lastLookedItem: [],
            lastLookedItemLoading: true,
            placeholderItem: {
                "productId": undefined,
                "title": "-",
                "subTitle": "-",
                "barcode": "-",
                "description": "-",
                "requiredPoint": "-",
                "rewardPoint": "-",
                "quantity": "-",
                "price": "-",
                "largeImageUrl": undefined,
                "smallImageUrl": undefined,
                "giftEnable": false,
                "inStock": false,
                "productCategory": null,
                "usage": "",
                "ingredients": "",
                "warnings": "",
                "videoUrl": "",
                "skinType": null
            },
            qrVisible: false,
            qrStarting: false,
            qrError: null,
            qrWarnVisible: false,
            qrWarnDesc: null
        }
        this.productAddForm = React.createRef();
        this.productInput = React.createRef();

        this.product_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'usedAt',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.usedAt).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'Ürün Barkodu',
                dataIndex: 'productBarcode',
                render: (name, record) => record?.productBarcode || record?.productBarcode?.length > 0 ? record?.productBarcode : '-',
            },
            {
                title: 'Ürünün İsmi',
                dataIndex: 'productName',
                render: (name, record) => record?.productName ?? '-',
            },
            {
                title: 'Puan Kodu',
                dataIndex: 'code',
                render: (name, record) => record?.code || record?.code?.length > 0 ? record?.code : '-',
            },
            {
                title: 'Kazanılan Puan',
                dataIndex: 'points',
                render: (name, record) => record?.points ? '+' + record?.points + ' Puan' : '-',
            },
        ]

        this.timerProductAdd = null;
        this.qrcodeArea = React.createRef();
    }

    html5QrCode = null;
    qrHandled = false;

    updateWindowWidth = () => {
        this.setState({
            width: window.innerWidth
        });
    };

    async componentDidMount() {
        window.addEventListener('resize', this.updateWindowWidth);

        const {pagination} = this.state;
        this.getTransactions({pagination});

        try {
            const slidersData = await Api.getAllBanner();
            const filteredData = Object.values(slidersData?.data?.sliders).find(item => item?.template?.main?.id === 7);
            this.setState({
                sliders: (filteredData?.list && filteredData?.list?.length > 0) ? filteredData.list : [],
                sliderLoading: false
            });
        } catch (e) {
            this.setState({
                sliderLoading: false
            });
        }

        this.getTop5Products();
        this.bestSeller();

        let lastLookedItemTemp = JSON.parse(localStorage.getItem('consumerLastLookedItems')) ?? [];
        this.setState({lastLookedItem: lastLookedItemTemp}, () => this.setState({lastLookedItemLoading: false}));

        Api.getCustomer().then(r2 => {
            const {remember} = UserInfo.dataCheck();
            UserInfo.setUserInfo(r2?.data, remember);
        }).catch((e) => {
            HelperGeneral.alert(e);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowWidth);
        this.stopQrScanner(false);
    }

    productAddEvent = (e) => {
        let code = e?.code;
        const extracted = HelperGeneral.extractQrcodeFromUrlOrRaw(code);
        if (extracted?.code) code = extracted.code;
        this.productAdd(code);
    }

    productAdd = (code, result = null) => {
        const index = this.state.transactions.length;

        this.setState({
            transactions: [...this.state.transactions, {code}],
            productInputLoading: true
        }, () => {
            const data = {
                code: code
            };

            Api.transactionAdd(data).then((a) => {
                this.setState({
                    transactions: _.remove(this.state.transactions, index),
                }, () => {
                    Api.getCustomer().then(r2 => {
                        const {remember} = UserInfo.dataCheck();
                        UserInfo.setUserInfo(r2?.data, remember);
                    }).catch((e) => {
                        HelperGeneral.alert(e);
                    });
                    this.getTop5Products();
                    HelperGeneral.alert('Puan başarılı bir şekilde hesabınıza eklendi!', 'success');
                    this.productAddForm?.current?.resetFields();
                    this.getTransactions({pagination: {current: 1, pageSize: 10}});
                    if (result) return result();
                });
            }).catch((e) => {
                const transactions = this.state.transactions;

                transactions[index]['error'] = HelperGeneral.getErrorText(e, code);
                transactions[index]['errorTime'] = Date.now() + 7000;
                transactions[index]['key'] = HelperGeneral.uuidv4();
                this.productAddForm?.current?.resetFields();
                this.setState({
                    transactions: transactions,
                    productInputLoading: false,
                }, () => {
                    if (result) return result();
                });
            });
        });
    }

    findProductInput = () => {
        if (this.productInput.current.state.value === '' ||
            this.productInput.current.state.value === undefined) {
            this.setState({
                transactions: [
                    {
                        required: true,
                        error: 'Puan kodu girişi zorunludur',
                    },
                ],
            })
        }
    }

    handleTableChange = (pagination) => {
        this.getTransactions({
            pagination,
        });
        HelperGeneral.scrollToClassName('.product-area');
    }

    getTransactions = (params = {}) => {
        this.setState({loading: true}, () => {
            Api.getTransactions(params.pagination.current, params.pagination.pageSize).then(response => {
                this.setState({
                    loading: false,
                    product_data: response?.data?.data,
                    pagination: {
                        ...params.pagination,
                        total: response?.total,
                    },
                });
            }).catch((e) => {
                this.setState({
                    loading: false,
                    productInputLoading: false,
                }, () => HelperGeneral.alert(e));
            });
        });
        setTimeout(() => {
            this.setState({productInputLoading: false});
        }, 2000);
    }

    getTop5Products = () => {
        Api.getTop5().then((response) => {
            this.setState({getTop5Products: response?.data?.data?.slice(0, 5)}, () => this.setState({top5Loading: false}));
        }).catch((error) => {
            HelperGeneral.alert(error);
            this.setState({top5Loading: false});
        });
    }

    bestSeller = () => {
        Api.bestSeller().then((response) => {
            this.setState({getTop5SellerProducts: response?.data?.data?.slice(0, 5)}, () => this.setState({top5Loading: false}));
        }).catch((error) => {
            HelperGeneral.alert(error);
            this.setState({top5Loading: false});
        });
    }

    top5HTML = (type = 1) => {
        const {getTop5Products, getTop5SellerProducts} = this.state;

        const temp = type === 1 ? getTop5Products : getTop5SellerProducts;

        function tempFunc(a, i) {
            const v = a?.product;
            return '<div class="product" key="' + (i + 5) + '">' + '<div class="number">' + (i + 1) + '</div><div class="img"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '"><img src="' + (v?.image && v?.image?.length > 0 ? v?.image : require('../../../assets/images/png/default-product.png')) + '" alt="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '"/></a>' +
                '</div><div class="details"><div class="title"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '">' + HelperGeneral.strShort((v?.name && v?.name?.length > 0 ? v?.name : '-'), 36) + '</a></div><div class="desc">' + HelperGeneral.strShort((v?.code ?? '-'), 50) + '</div>' +
                '<div class="' + (v?.name !== '-' ? 'stars score-5' : 'stars score-0') + '"><span></span><span></span><span></span><span></span><span></span></div></div></div>';
        }

        let content = '';
        content += '<div class="left">';
        let y = temp?.length > 0 ? temp?.map(function (a, i) {
            const v = a?.product;
            if (i == 0) {
                content += '<div class="product" key="' + (i + 10) + '">' + '<div class="img"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '"><img src="' + (v?.image && v?.image?.length > 0 ? v?.image : require('../../../assets/images/png/default-product.png')) + '" alt="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '"/></a>' +
                    '</div><div class="details"><div class="number">' + (i + 1) + '</div><div class="title"><a title="' + (v?.name && v?.name?.length > 0 ? v?.name : '-') + '" href="' + (v?.id ? '/urunler/' + v?.id : '#') + '">' + HelperGeneral.strShort((v?.name && v?.name?.length > 0 ? v?.name : '-'), 33) + '</a></div><div class="desc">' + HelperGeneral.strShort((v?.code ?? '-'), 50) + '</div>' +
                    '<div class="' + (v?.name !== '-' ? 'stars score-5' : 'stars score-0') + '"><span></span><span></span><span></span><span></span><span></span></div></div></div>';
            }
        }) : null;
        content += '</div>';
        content += '<div class="right">';
        let x = temp?.length > 0 ? temp?.map(function (v, i) {
            if (i > 0) {
                content += tempFunc(v, i);
            }
        }) : null;
        content += '</div>';
        return ReactHtmlParser(content);
    }

    openQrScanner = async () => {
        this.setState({ qrVisible: true, qrStarting: true, qrError: null });

        setTimeout(async () => {
            try {
                await this.stopQrScanner(false);

                this.html5QrCode = new Html5Qrcode('qr-reader');

                const config = { fps: 10, qrbox: { width: 260, height: 260 } };

                await this.html5QrCode.start(
                    { facingMode: 'environment' },
                    config,
                    (decodedText) => {
                        this.onQrDecoded(decodedText);
                    },
                    () => {}
                );

                this.setState({ qrStarting: false });
            } catch (err) {
                this.setState({
                    qrStarting: false,
                    qrError: 'Kamera açılamadı. Tarayıcı izinlerini kontrol edin.',
                });
            }
        }, 50);
    };

    onQrDecoded = async (decodedText) => {
        if (this.qrHandled) return;
        this.qrHandled = true;

        const parsed = this.parseQrPayload(decodedText);

        await this.stopQrScanner(true);

        if (parsed.type === 'pharmacy') {
            this.setState({ qrWarnVisible: true, qrWarnDesc: 'Okutmuş olduğunuz QR kodu eczaneye aittir. Lütfen ürün ambalajı üzerinde, alt tarafta bulunan QR kodunu okutunuz.' });
            this.qrHandled = false;
            return;
        }

        if (parsed.type === 'consumer' && parsed.code) {
            if (this.productAddForm?.current?.setFieldsValue) {
                this.productAddForm.current.setFieldsValue({ code: parsed.code });
            }

            if (this.productInput?.current?.focus) {
                this.productInput.current.focus();
            }

            message.success('Kod okundu, ekleniyor...');

            if (this.productAddForm?.current?.submit) {
                this.productAddForm.current.submit();
            } else {
                this.productAddEvent({ code: parsed.code });
            }

            this.qrHandled = false;
                return;
        }

        this.setState({ qrWarnVisible: true, qrWarnDesc: 'Okunan QR formatı geçersiz. Lütfen doğru QR kodunu okutunuz.' });
        this.qrHandled = false;
    };

    stopQrScanner = async (closeModal = true) => {
        try {
            if (this.html5QrCode) {
                await this.html5QrCode.stop();
                await this.html5QrCode.clear();
                this.html5QrCode = null;
            }
        } catch (e) {
            this.html5QrCode = null;
        }

        if (closeModal) {
            this.setState({ qrVisible: false, qrError: null, qrStarting: false });
        }
    };

    parseQrPayload = (raw) => {
        const text = (raw || '').trim();
        if (!text) return { type: 'unknown' };

        // Tarayıcı hatalarını düzelt (Ç→., *→-) ve URL/pasta ile gelen koddan qrcode çıkar
        const extracted = HelperGeneral.extractQrcodeFromUrlOrRaw(text);
        if (extracted && extracted.code) {
            return { type: 'consumer', code: extracted.code };
        }

        const normalized = HelperGeneral.normalizeScannerQrInput(text);
        let path = normalized;
        try {
            const u = new URL(normalized);
            path = u.pathname;
        } catch (e) {
            path = normalized;
        }

        const consumerMatch = path.match(/\/qr\/([A-Za-z0-9]+)\/?$/);
        const pharmacyMatch = path.match(/\/qr\/([^\/]+)-([A-Za-z0-9]+)\/?$/);
        const pharmacyMatchDot = path.match(/\.qr\.([^\s.]+)-?([A-Za-z0-9]+)?/i);

        if (pharmacyMatch) {
            return { type: 'consumer', code: pharmacyMatch[2] };
        }
        if (pharmacyMatchDot && pharmacyMatchDot[2]) {
            return { type: 'consumer', code: pharmacyMatchDot[2] };
        }

        if (consumerMatch) {
            return { type: 'consumer', code: consumerMatch[1] };
        }

        return { type: 'unknown' };
    };

    render() {
        const {
            width,
            product_data,
            pagination,
            loading,
            sliders,
            transactions,
            top5Loading,
            lastLookedItem,
            lastLookedItemLoading,
            getTop5SellerProducts,
            getTop5Products,
            sliderLoading
        } = this.state;

        let firstCategoryLink = "/kategori/daily/temel-bakim";
        const isMobile = width <= 991;

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animation,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
        };

        const itemCount = Array.isArray(lastLookedItem) ? lastLookedItem?.length : 0;
        const slides = (max) => {
            if (itemCount === 1) return 2;
            return Math.min(itemCount || max, max);
        };
        const showArrows = (min) => itemCount >= min;
        const settings = {
            slidesToShow: slides(4),
            slidesToScroll: slides(4),
            arrows: showArrows(5),
            autoplay: false,
            autoplaySpeed: 5000,
            infinite: false,
            centerMode: false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: slides(3),
                        slidesToScroll: slides(3),
                        arrows: showArrows(4),
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: showArrows(3),
                    }
                },
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: showArrows(2),
                    }
                }
            ]
        };

        const lottieLoading = () => (
            <div className="position-absolute w-100 h-100" style={{pointerEvents: "none"}}>
                <Lottie options={defaultOptions}/>
            </div>
        );

        return (
            <Container className={'home-consumer-page home-page'}>
                <Row className={'mt-4 rounded'}>
                    <Col xs={12} xl={9} className={'carousel-col'}>
                        <Spin spinning={sliderLoading} className={'h-100'}>
                            <Carousel
                                className={'carousel'}
                                nextIcon={<FontAwesomeIcon icon={faAngleRight} style={{color: 'black', fontSize: 20}}/>}
                                prevIcon={<FontAwesomeIcon icon={faAngleLeft} style={{color: 'black', fontSize: 20}}/>}
                                touch={true}
                                controls={width > 991}
                                indicators={width > 991}
                            >
                                {
                                    sliders?.map((v, i) => (
                                        <Carousel.Item key={i} className={'h-100'}>
                                            <a
                                                href={'#'}
                                                onClick={() => {
                                                    if (v?.category && v?.category?.info && v?.category?.info?.slug) {
                                                        HelperGeneral.pageChange(this, '/kategori/' + v?.category?.info?.slug)
                                                    } else {
                                                        HelperGeneral.pageChange(this, '/kategori/daily/temel-bakim')
                                                    }
                                                }}
                                            >
                                                <img
                                                    className={'d-block w-100 h-100'}
                                                    style={{objectFit: 'cover'}}
                                                    src={v?.image_urls?.image?.raw ?? v?.image_urls?.image?.w750x}
                                                    alt={i}
                                                />
                                            </a>
                                        </Carousel.Item>
                                    ))
                                }
                            </Carousel>
                        </Spin>
                    </Col>
                    <Col xs={12} xl={3}>
                        <div className={'gift-box h-100 rounded pb-0 position-relative'}>
                            {lottieLoading()}
                            <Container>
                                <Row className={'pt-3 position-relative'} style={{zIndex: 1}}>
                                    <Col xs={8} className={"mx-auto d-flex align-items-center justify-content-center text-center mb-2"}>
                                        <div className={"point"}>
                                            <div className={"point-circle shadow"}>
                                                <Container className={'h-100'}>
                                                    <Row className={"h-100"}>
                                                        <Col xs={12} className={"d-flex align-items-end justify-content-center"}>
                                                            <h1>
                                                                {UserInfo.info('score') ?? '0'}
                                                            </h1>
                                                        </Col>
                                                        <Col xs={12} className={"d-flex align-items-start justify-content-center"}>
                                                            <img
                                                                src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                className={'q-point-logo'}
                                                                alt={'q-point-logo'}
                                                            />
                                                            <span className={'mt-1'}>Puan</span>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col
                                        xs={12}
                                        className={'d-flex align-items-center justify-content-center text-center mb-1 text-black'}
                                        style={{fontSize: 20}}
                                    >
                                        {UserInfo.fullUserName()}
                                    </Col>
                                    <Col
                                        xs={12}
                                        className={'d-flex align-items-center justify-content-center text-center mb-1'}
                                        style={{fontSize: 14}}
                                    >
                                        <a
                                            href={'/my-account/info'}
                                            target={'_blank'}
                                            className={'text-black profile-btn'}
                                        >
                                            Profilini Düzenle
                                        </a>
                                    </Col>
                                    <Col
                                        xs={12}
                                        className={'d-flex align-items-center justify-content-center text-center mb-3'}
                                    >
                                        <a href={firstCategoryLink} className={'text-black btn '}>
                                            Hediye Ürününü Seç
                                        </a>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                    <Col xs={12} className={'mt-4'}>
                        <div className={'product-area  ' + (transactions.length > 0 ? 'processing' : '')}>
                            <Container className={'point-container'}>
                                <Row>
                                    <Col
                                        className={'my-auto'}
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={true}
                                    >
                                        <div className={'description-area consumer'} ref={this.qrcodeArea}>
                                            <p className={'t1'}>Q PUAN KAZAN</p>
                                            <p className={'t2'}>
                                                Shiniq dünyasına katılın ve sadakat programımıza ücretsiz üye olun.
                                                Aldığınız Shiniq ürününün yan tarafında yer alan QR kodu kazıyın ve puan kodunuzu belirtilen alana girin.
                                                Her alışverişinizde Q Puan kazanmaya başlayın ve puanlarınızı biriktirin.
                                                Biriktirdiğiniz puanlarla dilediğiniz hediyeyi seçin.
                                            </p>
                                        </div>
                                    </Col>
                                    <Col
                                        className={'my-auto'}
                                        xs={12}
                                        md={12}
                                        lg={'auto'}
                                        style={{paddingRight: width > 992 ? '24px' : '12px'}}
                                    >
                                        <Form onFinish={(e) => this.productAddEvent(e)} ref={this.productAddForm}>
                                            <Container>
                                                <Row className={'p-0'}>
                                                    <Col
                                                        xs={12}
                                                        md={8}
                                                        lg={'auto'}
                                                        style={{ position: 'relative' }}
                                                        className={"mb-lg-0 mb-md-3"}
                                                    >
                                                        <Form.Item
                                                            name={'code'}
                                                            rules={[{ required: true, message: 'Lütfen bu alanı doldurunuz' }]}
                                                        >
                                                            <Input
                                                                autoComplete={'off'}
                                                                placeholder={'Lütfen puan kodunu giriniz'}
                                                                ref={this.productInput}
                                                                disabled={this.state.productInputLoading}
                                                                onPaste={(e) => {
                                                                    const pasted = (e.clipboardData || window.clipboardData)?.getData?.('text') || '';
                                                                    const extracted = HelperGeneral.extractQrcodeFromUrlOrRaw(pasted);
                                                                    if (extracted?.code) {
                                                                        e.preventDefault();
                                                                        this.productAddForm?.current?.setFieldsValue?.({ code: extracted.code });
                                                                    }
                                                                }}
                                                                suffix={
                                                                    isMobile ? (
                                                                        <CameraOutlined
                                                                            style={{
                                                                                fontSize: 24,
                                                                                cursor: 'pointer',
                                                                                color: '#1890ff'
                                                                            }}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation(); // input focus bozulmasın
                                                                                this.openQrScanner();
                                                                            }}
                                                                        />
                                                                    ) : null
                                                                }
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={12} md={true}>
                                                        <div className={`d-flex ${isMobile ? 'flex-column flex-md-row' : ''} gap-2`}>
                                                            <Button htmlType={'submit'} onClick={(e) => this.findProductInput(e)}>
                                                                Puan Kodunu Ekle
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Form>
                                    </Col>
                                    <Col xs={12} className={'p-0'}>
                                        <div className={'process-area'}>
                                            {
                                                transactions?.map((v, i) => (
                                                    <div className={(v?.error ? 'error' : '')} key={i}>
                                                        <div>
                                                            {
                                                                !v.required ? (
                                                                    v?.error ? (
                                                                        <>
                                                                            Üzgünüz, {v?.code} numaralı ürün eklenemedi:<span style={{marginLeft: '6px'}}>{v?.error}</span>
                                                                        </>
                                                                    ) : (
                                                                        v?.code + ' numaralı ürün için işlem devam ediyor...'
                                                                    )
                                                                ) : (
                                                                    v?.error
                                                                )
                                                            }
                                                        </div>
                                                        <div>
                                                            {
                                                                v?.error && (
                                                                    <Countdown
                                                                        precision={0}
                                                                        renderer={({minutes, seconds,}) => (
                                                                            <span className={'pe-2 countdown d-none'}>
                                                                                Kapanacak: {zeroPad(seconds)}
                                                                            </span>
                                                                        )}
                                                                        onComplete={() => {
                                                                            const transactions = _.remove(this.state.transactions,
                                                                                (v1, i1) => {
                                                                                    return i1 !== i
                                                                                })
                                                                            this.setState({transactions: transactions})
                                                                        }}
                                                                        date={v.errorTime}
                                                                        key={v.key}
                                                                        autoStart={true}
                                                                    />
                                                                )
                                                            }
                                                            <FontAwesomeIcon
                                                                className={'d-none'}
                                                                icon={v.error ? faExclamation : faSpinner}
                                                                spin={!v.error}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </Col>
                </Row>
                <div className={'product-history box mt-4 mb-0'}>
                    <h3 className={'table-h3'}>Puan Kazandığın Ürünler</h3>
                    <Table
                        columns={this.product_history_column}
                        rowKey={record => record.transactionId}
                        dataSource={product_data}
                        pagination={{
                            ...pagination,
                            showSizeChanger: true,
                            pageSizeOptions: ['15', '30', '45', '60', '100'],
                            responsive: false,
                        }}
                        loading={loading}
                        onChange={this.handleTableChange}
                    />
                </div>
                <Row>
                    <Col>
                        <Spin spinning={top5Loading}>
                            <section className="three-block-area">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-6 area-col">
                                            <div className={getTop5SellerProducts?.length > 0 ? "box top-products type1" : "box top-products type1 empty"}>
                                                <div className="box-head">
                                                    <div className="title">En Çok Satanlar</div>
                                                </div>
                                                <div className="box-content">
                                                    <div className="top-products">
                                                        {
                                                            getTop5SellerProducts?.length > 0 ? (
                                                                this.top5HTML(2)
                                                            ) : (
                                                                !top5Loading && (
                                                                    <Empty description={'Top 5 Ürün Bulunamadı.'}/>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 area-col">
                                            <div className={getTop5Products?.length > 0 ? "box top-products type2" : "box top-products type2 empty"}>
                                                <div className="box-head">
                                                    <div className="title">En Çok Puan Kazandıranlar</div>
                                                </div>
                                                <div className="box-content">
                                                    <div className="top-products">
                                                        {
                                                            getTop5Products?.length > 0 ? (
                                                                this.top5HTML(1)
                                                            ) : (
                                                                !top5Loading && (
                                                                    <Empty description={'Top 5 Ürün Bulunamadı.'}/>
                                                                )
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </Spin>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Spin spinning={lastLookedItemLoading}>
                            <Container className={'d-flex justify-content-center last-looked-container mt-4 mt-sm-2'}>
                                <Row className={'slider-row-container'}>
                                    <Col xs={12}>
                                        <h3>Son Bakılan Ürünler</h3>
                                    </Col>
                                    <Col>
                                        {
                                            lastLookedItem?.length !== 0 && !lastLookedItemLoading > 0 ? (
                                                <Slider {...settings}>
                                                    {
                                                        lastLookedItem?.map((v) => {
                                                            return (
                                                                <div key={v?.id} className={'custom-slider-items-container'}>
                                                                    <div className={'large-image'}>
                                                                        <Link to={'/product/' + v?.slug} onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}>
                                                                            <img src={v?.images[0]?.w250x ?? require('../../../assets/images/png/default-product.png')}/>
                                                                        </Link>
                                                                    </div>
                                                                    <div className={'custom-title'} style={{maxHeight: `${3 * 1.1}em`}}>
                                                                        <Link to={'/product/' + v?.slug} className={'title-style'} onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}>
                                                                            {v?.name ?? '-'}
                                                                        </Link>
                                                                    </div>
                                                                    <div className={'reward-section'} style={{visibility: (v?.gift_product === 1 && v?.gift_point > 0) ? 'visible' : 'hidden'}}>
                                                                        <span className={'reward-point'}>{HelperGeneral.formatPoint(v?.gift_point)}</span>
                                                                        <img
                                                                            className={'reward-section-img'}
                                                                            src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                        />
                                                                    </div>
                                                                    <div className={'examine-section'}>
                                                                        <Link className={'link'} to={'/product/' + v?.slug} onClick={() => HelperGeneral.addToLastLookedItem(v, 1)}>
                                                                            <span><FontAwesomeIcon icon={faSearch}/> İncele</span>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Slider>
                                            ) : (
                                                !lastLookedItemLoading && (
                                                    <div className={'pt-4'}>
                                                        <Empty description={'Son bakılan ürün bulunmamaktadır'}/>
                                                    </div>
                                                )
                                            )
                                        }
                                    </Col>
                                </Row>
                            </Container>
                        </Spin>
                    </Col>
                </Row>
                <Modal
                    visible={this.state.qrVisible}
                    onCancel={() => this.stopQrScanner(true)}
                    footer={null}
                    centered
                    destroyOnClose
                    title="QR Okut"
                >
                    {this.state.qrError && (
                        <div style={{ marginBottom: 12, color: 'red' }}>{this.state.qrError}</div>
                    )}

                    <div style={{ width: '100%' }}>
                        <div id="qr-reader" style={{ width: '100%' }} />
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <Button onClick={() => this.stopQrScanner(true)}>
                            Kapat
                        </Button>
                    </div>
                </Modal>
                <Modal
                    visible={this.state.qrWarnVisible}
                    centered
                    footer={null}
                    onCancel={() => this.setState({ qrWarnVisible: false, qrWarnDesc: null })}
                    title="Uyarı"
                >
                    <div style={{ fontSize: 14 }}>
                        {this.state.qrWarnDesc}
                    </div>

                    <div className="d-flex justify-content-end mt-3" style={{ gap: 8 }}>
                        <Button onClick={() => this.setState({ qrWarnVisible: false, qrWarnDesc: null  })}>
                            Kapat
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                this.setState({ qrWarnVisible: false, qrWarnDesc: null  }, () => {
                                    this.openQrScanner();
                                });
                            }}
                        >
                            Tekrar Okut
                        </Button>
                    </div>
                </Modal>
            </Container>
        )
    }
}

export default withRouter(Home);
